module.exports = __webpack_public_path__ + "img/empty1.f12ad40d.png";